// 获取帖子数据
export function getLinkData () {
  return window.HeyboxRequest.base()
}

// 获取游戏卡片数据(多个)
export function getGameCardsData (args) {
  let url = '/game/get_game_infos/'
  return window.HeyboxRequest.get(url, args)
}

// 获取商品卡片数据(多个)
export function getSkuCardsData (args) {
  let url = '/mall/sku/detail/'
  return window.HeyboxRequest.get(url, args)
}

// 获取百科卡片数据(多个)
export function getWikiCardsData (args) {
  let url = '/wiki/get_wiki_infos'
  return window.HeyboxRequest.get(url, args)
}

// 获取联赛卡片数据(多个)
export function getLeagueCardsData (args) {
  let url = '/game/match/leagues'
  return window.HeyboxRequest.get(url, args)
}

// 获取赛事卡片数据(多个)
export function getMatchCardsData (args) {
  let url = '/game/match/batch_match_data'
  return window.HeyboxRequest.get(url, args)
}

// 获取游戏单卡片数据(多个)
export function getAlbumCardsData (formatData) {
  let url = '/game/self_made_game_list/data/infos'
  return window.HeyboxRequest.post(url, {}, formatData)
}

// 获取dota比赛战报卡片数据(单个)
const dota2_match_record = {}
export function getDota2MatchRecordCardsData (args) {
  if (!(args.match_id in dota2_match_record)) {
    let url = '/game/dota2/timeline/news_data'
    dota2_match_record[args.match_id] = window.HeyboxRequest.get(url, args)
  }
  return dota2_match_record[args.match_id]
}

// 获取dota比赛战报卡片数据(单个)
const lol_match_record = {}
export function getLOLMatchRecordCardsData (args) {
  if (!(args.match_id in lol_match_record)) {
    let url = '/game/lol/match/game/data'
    dota2_match_record[args.match_id] = window.HeyboxRequest.get(url, args)
  }
  return dota2_match_record[args.match_id]
}

// 关注/取关作者
export function togglefollowPosterState (type, formatData) {
  switch (type) {
    case 'unfollow': {
      var url = '/bbs/app/profile/follow/user/cancel'
      break
    }
    case 'follow': {
      var url = '/bbs/app/profile/follow/user'
      break
    }
  }
  return window.HeyboxRequest.post(url, {}, formatData)
}

// 提交投票
export function submitVoteResult (formatData) {
  let url = '/bbs/app/link/vote'
  return window.HeyboxRequest.post(url, {}, formatData)
}

// 关注/取消关注游戏
export function toggleFollowGameState (type, formatData) {
  if (type == 'follow') {
    var url = '/account/follow_game/'
  } else {
    var url = '/account/unfollow_game/'
  }
  return window.HeyboxRequest.post(url, {}, formatData)
}

// 订阅/取消订阅比赛
export function toggleWatchMatchState (type, args) {
  if (type == 'watch') {
    var url = '/game/match/watch_match_from_app'
  } else {
    var url = '/game/match/unwatch_match_from_app'
  }
  return window.HeyboxRequest.get(url, args)
}

// 收藏/取消收藏游戏单
export function toggleFollowAlbumState (args) {
  var url = '/game/self_made_game_list/favour/client'
  return window.HeyboxRequest.get(url, args)
}

// 发奖表格数据获取
export function getAwardTableCardData (args) {
  var url = '/bbs/app/api/article/get_award_users'
  return window.HeyboxRequest.get(url, args)
}

// 发奖表格数据获取
export function getChatRoomCardData (args) {
  var url = '/chatroom/v2/room/card_info'
  return window.HeyboxRequest.get(url, args)
}